<template>
  <div v-show="$store.state.cart.commerceItemCount > 0">
    <div v-if="isExpanded == true">
      <form @submit.prevent="addPromoCode" class="promo-code-form d-flex">

        <div class="input-group mb-3">
          <input v-model.trim="promoCode" class="form-control" required :class="{ 'promo-code-input-filled': promoCode.length > 0 }">

          <div class="input-group-append" v-if="promoCode.length > 0">
            <label class="fa fa-times-circle remove-promo-code" @click="promoCode = ''"></label>
            <!-- <button class="btn btn-outline-secondary" type="button" id="button-addon2">Button</button> -->
            <button  class="btn btn-primary promo-code-submit">Apply</button>
          </div>
        </div>
        <label v-show="promoCode.length < 1" class="promo-code-placeholder"><span class="fa fa-scissors"></span> Promo Code</label>
      </form>
    </div>
    <div v-else>
      <a @click.prevent="isExpanded=true" href="#" class="system-link">Have a promo code?</a>
    </div>

    <error-container v-bind:type="'promoCode'"></error-container>

  </div>

</template>

<script>
import Errors from '../Errors'

export default {
  name: 'CartPromoCode',
  components: {
    'error-container': Errors
  },
  props: {
    expanded: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      promoCode: '',
      isExpanded: this.expanded
    }
  },
  methods: {
    addPromoCode: function () {
      this.$store.dispatch('cart/POST_PROMO_CODE', {
        promoCode: this.promoCode
      })
    },
    deletePromoCode: function (promoCode) {
      this.$store.dispatch('cart/DELETE_PROMO_CODE', promoCode)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.promo-code-input-filled {
  padding-right: 20px;
}

.promo-code-form {
  position: relative;
}

.promo-code-placeholder {
  position: absolute;
  top: 8px;
  left: 8px;
  opacity: .5;
  pointer-events: none;
  z-index: 4;
}

.remove-promo-code {
  position: absolute;
  color: #ccc;
  z-index: 5;
  font-size: 18px;
  right: 85px;
  top: 9px;
}

.alert-icon {
  align-self: center;
  margin-right: 12px;
}
</style>

<docs>
 The checkout page has a link to show the promo code input box.
 The cart page is automatically expanded
`<promocode :expanded=true></promocode>`
</docs>
